import React, { useState, useEffect, useCallback } from "react";
import * as yup from "yup";
import styles from "./languages_modal.module.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Modal, Button, Row, Col, Spinner } from "react-bootstrap";
import ApiActions from "api_actions";
import MyToast from "components/toast/toast";
import PolicyCheckbox from "components/payment_form/submit_booking_button/policy_checkbox/policy_checkbox";
import Loading from "components/loading";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import routes from "routing/routes";
import { useTranslation } from "react-i18next";
import supportedLanguages from "constants/supported_languages";
import moment from "moment";
import setUrlParams from "utils/set_url_params";
import { LANGUAGE } from "constants/storage_keys";
import getUrlParams from "utils/get_url_params";

export default function LanguagesModal({ showModal, setShowModal }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const store = localStorage.getItem(LANGUAGE);
  const [selectedLanguage, setSelectedLanguage] = useState(
    supportedLanguages?.find((lng) => store === lng?.key || lng?.key === "en"),
  );

  useEffect(() => {
    var usrlang = navigator.languages;
    let loop = true;
    usrlang.map((data) => {
      let val = supportedLanguages.find((lang) => lang.key === data);
      if (store) {
        loop = false;
        setSelectedLanguage(supportedLanguages?.find((lng) => store === lng?.key));
        moment.locale(store);
        setUrlParams({ lang: store }, history);
      }

      if (val && loop) {
        loop = false;
        setSelectedLanguage(val);
        moment.locale(val.key);
        setUrlParams({ lang: val.key }, history);
      }
      return data;
    });
  }, [history, store]);

  const handleLocaleChange = useCallback(
    (localeKey) => {
      i18n.changeLanguage(localeKey);
      moment.locale(localeKey);
      setUrlParams({ lang: localeKey }, history);
      localStorage.setItem(LANGUAGE, localeKey);
    },

    [i18n, history],
  );

  useEffect(
    function setSelectedLanguage() {
      const { lang } = getUrlParams();
      if (!lang) {
        return;
      }
      moment.locale(lang);
      i18n.changeLanguage(lang);
    },

    [i18n],
  );

  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
      centered
    >
      <Modal.Header closeButton>
        <div className={`${styles.language_item} ${styles.selected}`}>
          <img className={styles.flag} src={selectedLanguage?.img} alt={selectedLanguage?.value} />
          <span className={styles.language_name}>{t("general:locale")}</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.language_modal}>
          <div className={styles.language_list}>
            {supportedLanguages?.map((language) => (
              <div
                key={language.key}
                className={`${styles.language_item} ${
                  selectedLanguage?.key === language?.key ? styles.selected : ""
                }`}
                onClick={() => handleLocaleChange(language?.key)}
              >
                <img className={styles.flag} src={language?.img} alt={language?.value} />
                <span className={styles.language_name}>{language?.value}</span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
